import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const VportSplitQicon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 20"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23 0H1C0.4 0 0 0.4 0 1V19C0 19.6 0.4 20 1 20H23C23.6 20 24 19.6 24 19V1C24 0.4 23.6 0 23 0ZM22 9H13V2H22V9ZM11 2V9H2V2H11ZM2 11H11V18H2V11ZM13 18V11H22V18H13Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

VportSplitQicon.displayName = 'VportSplitQicon';
